"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importStar(require("react"));
const useOnOutsideClick_1 = require("../../../../Hooks/useOnOutsideClick");
const style = __importStar(require("./styled"));
const react_router_dom_1 = require("react-router-dom");
const Typography_1 = require("../../../../Components/UI/Typography");
const useHeaderData_1 = __importDefault(require("../../../../Hooks/useHeaderData"));
const useInitialData_1 = __importDefault(require("../../../../Hooks/useInitialData"));
const useTranslate_1 = require("../../../../Hooks/useTranslate");
const const_1 = require("@/Components/Page/SearchResultPage/const");
const Search = ({ setIsSearchOpen, isRegional, isTransparent }) => {
    const { t } = (0, useTranslate_1.useTranslate)();
    const [search, setSearch] = (0, react_1.useState)('');
    const [searchSuggestions, setSearchSuggestions] = (0, react_1.useState)();
    const wrapperRef = (0, react_1.useRef)(null);
    const location = (0, react_router_dom_1.useLocation)();
    const history = (0, react_router_dom_1.useHistory)();
    (0, useOnOutsideClick_1.useOnOutsideClick)(wrapperRef, () => setIsSearchOpen && setIsSearchOpen(false));
    // @TODO:  for quick search later!
    // const debounceTime = 700
    // const debouncedSearchValue = useDebounce(search, debounceTime)
    const regionsRef = (0, react_1.useRef)(null);
    const initData = (0, useInitialData_1.default)();
    const headerData = (0, useHeaderData_1.default)();
    (0, react_1.useEffect)(() => {
        var _a, _b;
        if (!headerData)
            return;
        const regionArr = [];
        (_b = (_a = headerData.settings) === null || _a === void 0 ? void 0 : _a.regions) === null || _b === void 0 ? void 0 : _b.forEach(r => { var _a; return (_a = r === null || r === void 0 ? void 0 : r.links) === null || _a === void 0 ? void 0 : _a.forEach(link => regionArr.push(link.href)); });
        if (!regionsRef.current) {
            regionsRef.current = regionArr.sort((a, b) => b.length - a.length);
        }
    }, [headerData]);
    const onSearch = (event) => {
        var _a, _b, _c;
        event && event.preventDefault();
        const trimmedSearch = search.trim();
        if (!(0, const_1.validateSearchQuery)(trimmedSearch) || trimmedSearch.length < const_1.MIN_SEARCH_LENGTH) {
            return;
        }
        const path = (_b = (_a = regionsRef === null || regionsRef === void 0 ? void 0 : regionsRef.current) === null || _a === void 0 ? void 0 : _a.find(r => location.pathname.includes(r))) !== null && _b !== void 0 ? _b : '/en/';
        history.push({
            pathname: (_c = initData.pages.searchPage) !== null && _c !== void 0 ? _c : `${path}search/`,
            search: `?query=${encodeURIComponent(trimmedSearch)}`
        });
        setIsSearchOpen === null || setIsSearchOpen === void 0 ? void 0 : setIsSearchOpen(false);
    };
    return (react_1.default.createElement(react_1.default.Fragment, null, isRegional ? (react_1.default.createElement(style.RegionalContainer, { isTransparent: isTransparent, onSubmit: e => onSearch(e) },
        react_1.default.createElement(style.RegionalSearchInput, { placeholder: t('/haldex/search_placeholder'), type: "search", name: "search", onChange: e => setSearch(e.target.value), value: search, autoFocus: true }),
        react_1.default.createElement(style.RegionalSearchIcon, { onClick: () => onSearch() }))) : (react_1.default.createElement(style.Background, null,
        react_1.default.createElement(style.SearchContainer, { ref: wrapperRef },
            react_1.default.createElement(style.Form, { onSubmit: e => onSearch(e) },
                react_1.default.createElement(style.SearchInput, { name: "search", placeholder: t('/haldex/search_placeholder'), type: "search", onChange: e => setSearch(e.target.value), value: search, autoFocus: true }),
                react_1.default.createElement(style.SearchIcon, { onClick: () => onSearch() }))),
        search && searchSuggestions && (searchSuggestions === null || searchSuggestions === void 0 ? void 0 : searchSuggestions.length) > 0 && (react_1.default.createElement(style.SuggestionContainer, null, searchSuggestions.map((item, i) => (react_1.default.createElement(style.ItemContainer, { key: i },
            react_1.default.createElement(style.ItemTitle, { type: Typography_1.Types.BODY_1 }, item.name),
            react_1.default.createElement(style.ItemCategory, { type: Typography_1.Types.BODY_3 }, item.category))))))))));
};
exports.default = (0, react_1.memo)(Search);
